<template>
  <div class="library-topics-component">
    <topic :topic="asset" />
  </div>
</template>

<script>
import Topic from '@components/topics/topic';

import LibraryMixin from '@/mixins/library';

export default {
  components: { Topic },
  mixins: [LibraryMixin],
  props: {
    asset: {
      type: Object,
    },
  },
  computed: {
    assetId() {
      const id = this.$route.params?.assetId;
      const numericId = +id;
      // Return numeric ID only if it's a valid number, otherwise return null
      return Number.isFinite(numericId) ? numericId : null;
    },
  },
  mounted() {
    // Only dispatch if we have a valid assetId
    if (this.assetId) {
      this.$store.dispatch('topics/load', { ids: [this.assetId], includeTags: true });
    }
  },
};
</script>
